import React, { ReactNode, useEffect, useState } from "react";
import styles from "./FestvalFab.module.scss";
import { Fab, NewButtonVariant } from "@bale/ui";
import { strings } from "intl/fa";
import { QuestionFr } from "@bale/icons";
import Modal from "components/commons/modal/Modal";
import { useSelector } from "react-redux";
import { selectFestivalState } from "core/luckyWheel/luckyWheel.selector";
import { WheelState } from "core/luckyWheel/luckyWheel.api";
import { useNavigate } from "react-router-dom";

const FestivalFab = () => {
  const navigate = useNavigate();
  const [showFestivalModal, setShowFestivalModal] = useState(false);
  const festivalState = useSelector(selectFestivalState);

  const parser = (notes: (string | string[])[]) => {
    const result = [] as ReactNode[];

    notes.forEach((note) => {
      if (typeof note === "object") {
        result.push(<div className={styles.modalParagraph}>{parser(note)}</div>);
      } else {
        result.push(<p className={styles.modalText}>{note}</p>);
      }
    });

    return result;
  };

  return (
    <>
      {festivalState !== WheelState.INACTIVE && (
        <Fab
          className={styles.fab}
          text={
            festivalState === WheelState.WHEEL
              ? strings.festival.fabWheelTitle
              : strings.festival.fabTitle
          }
          icon={QuestionFr}
          onClick={
            festivalState === WheelState.WHEEL
              ? () => navigate("/luckyPage")
              : () => setShowFestivalModal(true)
          }
        />
      )}

      {showFestivalModal && (
        <Modal
          title={strings.festival.helpModal.title}
          onClose={() => setShowFestivalModal(false)}
          primaryButton={{
            label: strings.common.button.understood,
            variant: NewButtonVariant.OUTLINED,
            onClick: () => setShowFestivalModal(false),
          }}
        >
          <div className={styles.modalWrapper}>{parser(strings.festival.helpModal.notes)}</div>
        </Modal>
      )}
    </>
  );
};

export default FestivalFab;
